import { NgModule } from '@angular/core';
import { ClearanceItemBulkComponent } from './clearance-item-bulk.component';
import { ClearanceItemGroupNameComponent } from './clearance-item-groupname.component';
import { ClearanceItemBulkBarComponent } from './clearance-item-bulkbar.component';
import { SharedModule } from '../../shared/shared.module';
import { ClearanceItemCommonModule } from '../clearance-item-common.module';
import { AssetManagerModule } from '../../shared/asset-manager.module';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations:[
        ClearanceItemBulkComponent,
        ClearanceItemGroupNameComponent,
        ClearanceItemBulkBarComponent,
    ],
    imports: [
        ClearanceItemCommonModule,
        AssetManagerModule,
        SharedModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatIconModule,
        MatTooltipModule,
    ],
    exports:[
        ClearanceItemBulkComponent,
        ClearanceItemBulkBarComponent,
    ]
})
export class ClearanceItemBulkModule {

}
